import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const ModalHomologacionExcel = ({
  show,
  onHide,
  onSave,
  homologacion,
}) => {
  const [descripcion, setDescripcion] = useState("");
  const [columnaFecha, setColumnaFecha] = useState("");
  const [columnaTipoServicio, setColumnaTipoServicio] = useState("");
  const [columnaNumeroDocumento, setColumnaNumeroDocumento] = useState("");
  const [formatoFecha, setFormatoFecha] = useState("DD-MM-YYYY");
  const [activo, setActivo] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (homologacion) {
      setDescripcion(homologacion.descripcion || "");
      setActivo(homologacion.activo !== undefined ? homologacion.activo : true);
      
      // Cargar datos del detalle si existe
      if (homologacion.detalle) {
        setColumnaFecha(homologacion.detalle.columna_fecha_atencion || "");
        setColumnaTipoServicio(homologacion.detalle.columna_tipo_servicio || "");
        setColumnaNumeroDocumento(homologacion.detalle.columna_numero_documento || "");
        setFormatoFecha(homologacion.detalle.formato_fecha || "DD-MM-YYYY");
      }
    } else {
      setDescripcion("");
      setColumnaFecha("");
      setColumnaTipoServicio("");
      setColumnaNumeroDocumento("");
      setFormatoFecha("DD-MM-YYYY");
      setActivo(true);
    }
    setError("");
  }, [homologacion, show]);

  const handleSave = () => {
    // Validaciones
    if (!descripcion.trim()) {
      setError("La descripción es obligatoria");
      return;
    }

    if (!columnaFecha || parseInt(columnaFecha) < 1) {
      setError("La columna de fecha debe ser un número mayor a 0");
      return;
    }

    if (!columnaTipoServicio || parseInt(columnaTipoServicio) < 1) {
      setError("La columna de tipo de servicio debe ser un número mayor a 0");
      return;
    }

    if (!columnaNumeroDocumento || parseInt(columnaNumeroDocumento) < 1) {
      setError("La columna de número de documento debe ser un número mayor a 0");
      return;
    }

    const homologacionData = {
      descripcion: descripcion.trim(),
      activo: activo,
      detalle: {
        columna_fecha_atencion: parseInt(columnaFecha),
        columna_tipo_servicio: parseInt(columnaTipoServicio),
        columna_numero_documento: parseInt(columnaNumeroDocumento),
        formato_fecha: formatoFecha,
      }
    };

    onSave(homologacionData);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {homologacion ? "Editar Homologación" : "Nueva Homologación"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Descripción del Tipo de Homologación *</Form.Label>
            <Form.Control
              type="text"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Ej: Formato Proveedor ABC, Formato Estándar, Formato CSV"
              required
            />
            <Form.Text className="text-muted">
              Descripción que identifica el tipo de homologación/formato de Excel
            </Form.Text>
          </Form.Group>

          <hr />
          <h6 className="mb-3">Mapeo de Columnas del Excel</h6>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Columna Fecha de Atención *</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={columnaFecha}
                  onChange={(e) => setColumnaFecha(e.target.value)}
                  placeholder="Ej: 1, 2, 3..."
                  required
                />
                <Form.Text className="text-muted">
                  Número de columna (1 = A, 2 = B, etc.)
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Columna Tipo de Servicio *</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={columnaTipoServicio}
                  onChange={(e) => setColumnaTipoServicio(e.target.value)}
                  placeholder="Ej: 1, 2, 3..."
                  required
                />
                <Form.Text className="text-muted">
                  Número de columna (1 = A, 2 = B, etc.)
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Columna N° Documento *</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={columnaNumeroDocumento}
                  onChange={(e) => setColumnaNumeroDocumento(e.target.value)}
                  placeholder="Ej: 1, 2, 3..."
                  required
                />
                <Form.Text className="text-muted">
                  Número de columna (1 = A, 2 = B, etc.)
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Formato de Fecha *</Form.Label>
                <Form.Select
                  value={formatoFecha}
                  onChange={(e) => setFormatoFecha(e.target.value)}
                  required
                >
                  <option value="DD-MM-YYYY">DD-MM-YYYY (Ej: 17-01-2026)</option>
                  <option value="DD/MM/YYYY">DD/MM/YYYY (Ej: 17/01/2026)</option>
                  <option value="YYYY-MM-DD">YYYY-MM-DD (Ej: 2026-01-17)</option>
                  <option value="YYYY/MM/DD">YYYY/MM/DD (Ej: 2026/01/17)</option>
                  <option value="MM-DD-YYYY">MM-DD-YYYY (Ej: 01-17-2026)</option>
                  <option value="MM/DD/YYYY">MM/DD/YYYY (Ej: 01/17/2026)</option>
                </Form.Select>
                <Form.Text className="text-muted">
                  Formato en que viene la fecha en el Excel
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="activo-checkbox"
              label="Activo"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {homologacion ? "Actualizar" : "Crear"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHomologacionExcel;
